export function ActionFormButtonsContainer(props) {
    return (
        <div className='buttons-container'>
            {props.children}
        </div>
    );
}
